import { useBlockProps } from '@wordpress/block-editor';

export default function save( { attributes } ) {
	const {
		custom_size_width = 100,
		custom_size_height = 100,
		message = '__IMAGE__',
	} = attributes;

	return (
		<div
			{ ...useBlockProps.save() }
			style={ {
				width: isNaN(custom_size_width) || custom_size_width === '__IMAGE__' 
					? '150px' 
					: custom_size_width + 'px',
				height: isNaN(custom_size_height) || custom_size_height === '__IMAGE__' 
					? '150px' 
					: custom_size_height + 'px',
				marginInline: 'auto',
			} }
		>
			{ message }
		</div>
	);
}